import { Button } from '@cian/ui-kit';
import { IconCommunicationMessage16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './ChatButtonContainer.css';
import { useChats } from '../../hooks/useChats';
import { TContentType } from '../../types/content';
import { EDeviceType } from '../../types/device';
import { EStatus } from '../../types/filters';
import { IFavoriteEntity } from '../../types/results';

interface IChatButtonContainerProps {
  offer: IFavoriteEntity;
  position: number;
  total: number;
  deviceType: EDeviceType;
  type?: TContentType;
}

export const ChatButtonContainer: React.FC<IChatButtonContainerProps> = ({
  offer,
  position,
  total,
  deviceType,
  type = 'full',
}) => {
  const { isEnabled, openChat } = useChats({ offer, position, total, deviceType });

  const { status } = offer;

  if (!isEnabled || status !== EStatus.Published) {
    return null;
  }

  if (type === 'short') {
    return (
      <div className={styles['container']}>
        <Button
          size="XS"
          theme="fill_secondary"
          fullWidth
          beforeIcon={<IconCommunicationMessage16 color="icon-main-default" />}
          onClick={() => openChat()}
        >
          Написать
        </Button>
      </div>
    );
  }

  return (
    <Button fullWidth theme="fill_secondary" onClick={() => openChat()}>
      Написать
    </Button>
  );
};
